import React, {memo, useEffect, useState} from "react";
import FlyingEmoji from "./FlyingEmoji";

const States = {
    WAITING: 'WAITING',
    ANIMATING: 'ANIMATING',
    RESETTING: 'RESETTING'
}

const AMOUNT = 50;
const RANGE_Y = {min: -50, max: 100}
const LEFT_RIGHT_DEV = 20

const TOP_END = -1000

const generateEmojis = () => {
    const RANGE_X = {min: -100, max: document.getElementById('emoji-container').offsetWidth};
    return new Array(AMOUNT).fill().map(_ => ({
        left: Math.random() * (RANGE_X.max - RANGE_X.min) + RANGE_X.min,
        top: Math.random() * (RANGE_Y.max - RANGE_Y.min) + RANGE_Y.min
    }))
}

const moveEmojis = emojis => emojis.map(e => ({
    left: e.left + Math.random() * LEFT_RIGHT_DEV * 2 - LEFT_RIGHT_DEV,
    top: TOP_END
}));

const EmojiAnimation = ({emoji}) => {

    const [emojis, setEmojis] = useState([])
    const [animating, setAnimating] = useState(false)

    const newAnimation = () => setEmojis(generateEmojis())
    const startAnimation = () => setEmojis(e => moveEmojis(e))

    useEffect(() => {
        let t = null;
        if(emoji) {
            setAnimating(false)
            newAnimation()
            clearTimeout(t)
            t = setTimeout(() => {
                setAnimating(true)
                startAnimation()
            }, 100)
        }

        return () => {setAnimating(false)}
    }, [emoji])

    return (<>
        {emojis.map((e, i) => <FlyingEmoji key={i+''} animated={animating} emoji={emoji} left={e.left} top={e.top}/>)}
    </>);
}

export default memo(EmojiAnimation);